
export const LamColor = {
  Midnight: '#242437',
  Slate: '#6a7885',
  Mint: '#6ce3c6',
  Sand: '#e6e3dc',
  Yellow: '#f2c22e',
  Orange: '#e89945',
  DarkOrange: '#c74f26',
  DarkGreen: '#20a785',
  LinkDarkGreen: '#188167', // NEW for links
  gradientBlue: '#00d1fa',
  gradientMint: '#6ce3c6',
  gradientYellow: '#fff5b2',
};


export const LamBranding = {
  LabelFontSize: 12,
  LabelColor: LamColor.Midnight,
  ControlFontSize: 19, // UPDATED
  ControlBorderWidth: 1,
  ControlColor: LamColor.Midnight, // UPDATED for text color
  ControlHeight: 44, // UPDATED
  ControlPadding: 10, // Increase for better spacing
  ControlBorderRadius: 4,
  ControlBorderColor: LamColor.Slate,
  HoverBorderColor: LamColor.DarkGreen,
  HoverColor: LamColor.Midnight,
  HoverFill: LamColor.Mint,
};

export const LamFont = {
  Primary: 'Messina Sans, Arial, sans-serif',
  Bold: 'Messina Sans Bold, Arial Bold, sans-serif',
};


